// extracted by mini-css-extract-plugin
export default {"container":"Community_container__bY2WU","workcontainer":"Community_workcontainer__BiPbA"};